import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Divider,
  Heading,
  Image,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';
import { NavLink } from 'react-router-dom';

const ProjectCardV2 = (props) => {
  const cardBackground = useColorModeValue('white', 'gray.700');
  const infoColor = useColorModeValue('gray.500', 'gray.400');

  return (
    <Card
      as={NavLink}
      to={`/side_projects/${props.id}`}
      maxW="sm"
      h={'430px'}
      my={'1rem'}
      transition="transform 0.5s ease"
      backgroundColor={cardBackground}
      _hover={{
        transform: 'scale(1.1)',
        boxShadow: 'lg',
      }}
    >
      <CardBody >
        <Image src={props.src} alt="" borderRadius="lg" />
        <Stack mt="6" spacing="3">
          <Heading size="md">{props.title}</Heading>
          <Text color={infoColor}>{props.description}</Text>
          <Stack spacing={4} direction={'row'}>
            {props.techIcons?.map((techIcon, index) => {
              return <Image key={index} boxSize={8} src={techIcon} />;
            })}
          </Stack>
        </Stack>
      </CardBody>
      <Divider />
      <CardFooter p={3}>
        <Button textDecor={'underline'} variant="ghost" colorScheme="blue">
          Click To Learn More
        </Button>
      </CardFooter>
    </Card>
  );
};

export default ProjectCardV2;
